export class EventEmitter<
	TFn extends (...args: unknown[]) => unknown = (...args: unknown[]) => unknown,
> {
	private events: { [evtName: string]: Array<TFn> } = {};

	on(event: string, cb: TFn) {
		this.events[event] = this.events[event] || [];
		this.events[event].push(cb);
	}

	off(event: string, cb: TFn) {
		if (!(event in this.events)) return;
		this.events[event].splice(this.events[event].indexOf(cb), 1);
	}

	trigger(event: string, ...args: Parameters<TFn>) {
		if (!(event in this.events)) return;
		for (let i = 0; i < this.events[event].length; i += 1) {
			this.events[event][i].apply(this, Array.prototype.slice.call(args, 1));
		}
	}
}
